module.exports = __webpack_public_path__ + "img/trophy.dafc9014.png";